import { useEffect, useState } from "react";
import { Eye, EyeOff, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const bgImages = [
  "http://res.cloudinary.com/dt8emxboh/image/upload/v1768193083/xwjv4oxp4jvyw1d1vaah.png",
  "http://res.cloudinary.com/dt8emxboh/image/upload/v1768193188/xmfrpyla8lpi7qyl4tgq.png",
  "http://res.cloudinary.com/dt8emxboh/image/upload/v1768193243/r0cpcmakpt3jvsa73ipu.png",
];

export default function Login() {
  const navigate = useNavigate();

  const [bgIndex, setBgIndex] = useState(0);

  const [role, setRole] = useState("null");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  /* 🔁 Background rotation */
  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % bgImages.length);
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  /*  LOGIN HANDLER */
  const handleLogin = async () => {
    if (!email || !password) {
      alert("Email and Password required");
      return;
    }

    //  ADMIN BY DEFAULT IF NO ROLE SELECTED
    const finalRole = role && role !== "null" ? role : "admin";

    try {
      const res = await axios.post(
        "https://api.livestockify.com/api/admin/login",
        {
          email,
          password,
          role: finalRole,
        }
      );

      const data = res.data;

      /*  COMMON STORAGE */
      localStorage.setItem("token", data.token);
      localStorage.setItem("IsUserLogin", "true");

     


      if (finalRole === "admin") {
  const adminUserData = {
    name: `${data.firstName} ${data.lastName}`,
    email: data.email,
    userId: data.uuid,
  };

  localStorage.setItem(
    "adminUserData",
    JSON.stringify(adminUserData)
  );

  navigate("/all-users");
  return;
}

      /*  FUTURE ROLES (ready) */
     localStorage.setItem(
  "userData",
  JSON.stringify({
    name: data.name,
    email: data.email,
    userType: finalRole,
    userId: data.userId || data.uuid || null,
  })
);
    } catch (err) {
      console.error(err);
      alert("Email or password is incorrect");
    }
  };

  return (
    <div
      className="min-h-screen w-full bg-cover bg-center relative transition-all duration-1000"
      style={{ backgroundImage: `url(${bgImages[bgIndex]})` }}
    >
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 min-h-screen flex items-center justify-center px-4">
        <div
          className="w-full max-w-7xl flex flex-col lg:flex-row items-center 
                justify-center lg:justify-between gap-10  lg:gap-20"
        >
          {/* MOBILE TITLE */}
          <div className="block lg:hidden text-white text-center mb-4">
            <h1 className="text-4xl font-bold">
              Welcome to <span className="text-green-500">Kuppismart</span>
            </h1>
          </div>

          {/* DESKTOP TITLE */}
          <div className="hidden lg:flex flex-col text-white max-w-xl">
            <h1 className="text-7xl font-bold leading-tight mb-4">
              Welcome to <br />
              <span className="text-green-500">Kuppismart</span>
            </h1>
            <p className="text-sm opacity-90 font-bold">
              Access your smart IoT water monitoring and automation system to
              track water usage, automate controls, and monitor performance in
              real time.
            </p>
          </div>

          {/* LOGIN CARD */}
          <div
            className="w-full max-w-lg bg-white/40 rounded-2xl 
                px-8 py-10
                min-h-[400px] sm:min-h-[400px] lg:min-h-[420px]
                shadow-2xl border border-white/20 relative"
          >
            {/* 🔹 ROLE TABS (UNCHANGED) */}
            <div className="flex flex-nowrap items-center
  mt-6 mb-4 relative px-1 sm:px-2
  w-full">
              {["Farmer", "Veterinarian", "Organisation", "Supervisor"].map(
                (r, i) => (
                  <div key={r} className="flex items-center">
                    <button
                      onClick={() => setRole(r.toLowerCase())}
                      className={`px-1.5 sm:px-3 py-1
  text-[9px] sm:text-sm
  whitespace-nowrap transition
  flex-shrink-0
                        ${
                          role === r.toLowerCase()
                            ? "text-green-500 font-semibold"
                            : "text-white"
                        }
                      `}
                    >
                      {r}
                    </button>
                    {i !== 3 && <div className="h-4 w-px bg-white mx-2" />}
                  </div>
                )
              )}

              <button
                onClick={() => navigate("/")}
                className="absolute -top-10 right-0 flex items-center 
             text-sm font-bold text-black 
             py-2"
              >
                <ArrowLeft size={16} className="mr-1" /> Go Back
              </button>
            </div>

            <div className="w-full h-px bg-white mb-6" />

            {/* Email */}
            <div className="mb-4">
              <label className="font-medium flex text-black">Email ID</label>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Your Email ID"
                className="w-full mt-1 bg-white/90 rounded-md px-3 py-2 text-sm"
              />
            </div>

            {/* Password */}
            <div className="mb-8 relative">
              <label className="font-medium mb-0 flex text-black">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Your Password"
                className="w-full mt-2 bg-white/90 rounded-md px-3 py-2 text-sm"
              />
              <button
                onClick={() => setShowPassword(!showPassword)}
                className="absolute  right-3 top-10 text-gray-500"
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <button
              onClick={handleLogin}
              className="w-full bg-green-500 hover:bg-green-600 text-white py-2 rounded-md font-semibold"
            >
              SIGN IN
            </button>

            <p className="text-sm text-center font-bold mt-4">
              <span className="text-black">Don’t have an Account? </span>
              <span
                className="text-white cursor-pointer underline"
                onClick={() => navigate("/contact-admin")}
              >
                Contact Admin
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
